import { useEffect, useState } from "react";
import { Col, Container, Label, Row } from "reactstrap";
import { categories } from "../../dummyData";
import LabeledCheckedInput from "./LabeledCheckedInput";

const CategoriesSelectInput = ({ arrayValue, setArrayValue, label }) => {
  const [categoriesOptions, setCategoriesOptions] = useState(categories);
  console.log({ arrayValue });
  // write a fxn that determines which are selected
  useEffect(() => {
    if (arrayValue?.length > 0) {
      const updated = categories.map((cat) => ({
        ...cat,
        isSelected: arrayValue.some((selected) => selected.name === cat?.name),
      }));
      console.log({ updated });
      setCategoriesOptions(updated);
    } else {
      setCategoriesOptions(categories);
    }
  }, [arrayValue]);

  const handleCategorySelect = (value, item, index) => {
    let array = [...categoriesOptions];
    array[index].isSelected = value;
    setCategoriesOptions(array);
    let selectedCtaegories = array.filter((cat) => cat?.isSelected);
    setArrayValue(selectedCtaegories);
  };

  return (
    <div>
      <Label className="figma-input-label m-0">{label}</Label>

      <Row style={{ "--bs-gutter-y": "1.25rem" }} className="m-0">
        {categoriesOptions?.map((item, index) => (
          <Col lg={3} xl={2} md={4} key={index} className="p-0">
            <LabeledCheckedInput
              iconColor={item?.color}
              iconSize={30}
              label={item?.name}
              value={item?.isSelected}
              Icon={item?.icon}
              setValue={(v) => handleCategorySelect(v, item, index)}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default CategoriesSelectInput;
